
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedLow as ObiSpeedLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-low.js';
 
 
 

 
 export const ObiSpeedLow = createComponent({
   react: React,
   tagName: 'obi-speed-low',
   elementClass: ObiSpeedLowElement,
   events: {
     
   }
  });
 
 